import { RequestStatus } from '../enums/request-status';
import { RequestState } from '../types/request-state';

export const getInitialRequestState = (): RequestState => ({
  status: RequestStatus.Ideal,
  message: null,
  error: null,
});
